import Vue from 'vue'
import Vuex from 'vuex'
import client from 'api-client'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    movies: []
  },
  mutations: {
    setMovies(state, movies) {
      state.movies = movies
    }
  },
  actions: {
    fetchMovies({ commit }) {
      return client
        .fetchMovies()
        .then(movies => commit('setMovies', movies))
    }
  },
  modules: {
  }
})
